
import React from "react";
import { 
  Card, 
  CardHeader,
  CardContent 
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { TrendingUp } from "lucide-react";
import { KarmaActivity } from "@/types/database-extensions";

interface ActivityHistoryProps {
  activities: KarmaActivity[];
}

const ActivityHistory: React.FC<ActivityHistoryProps> = ({ activities }) => {
  return (
    <Card className="overflow-hidden border shadow-sm">
      <CardHeader className="p-4 bg-muted/30 border-b space-y-0">
        <h3 className="font-medium flex items-center text-base">
          <TrendingUp className="h-4 w-4 mr-2" />
          Recent Activity
        </h3>
      </CardHeader>
      
      <CardContent className="p-0">
        <div className="max-h-[280px] overflow-y-auto">
          {activities.length > 0 ? (
            <div className="divide-y">
              {activities.map((activity) => (
                <div key={activity.id} className="p-3.5 flex justify-between items-center">
                  <div>
                    <div className="font-medium text-sm">{activity.title}</div>
                    <div className="text-xs text-muted-foreground">
                      {new Date(activity.created_at).toLocaleDateString()}
                    </div>
                  </div>
                  <Badge variant="secondary" className="ml-2">+{activity.points} points</Badge>
                </div>
              ))}
            </div>
          ) : (
            <div className="py-10 px-4 text-center text-muted-foreground">
              <p className="mb-2">No activity yet</p>
              <p className="text-sm">Start earning points by claiming your daily and weekly bonuses!</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityHistory;
